const controllers = new WeakMap();

const postsGrid = {
  init() {
    document.querySelectorAll('.posts-grid').forEach((el) => this.bind(el));
  },

  bind(el) {
    const sortEl       = el.querySelector('.posts-grid__sort');
    const filterEl     = el.querySelector('.posts-grid__filter');
    const paginationEl = el.querySelector('.posts-grid__pagination');

    if (sortEl) {
      sortEl.addEventListener('change', () => this.load(el, 1));
    }

    if (filterEl) {
      filterEl.addEventListener('change', () => this.load(el, 1));
    }

    if (paginationEl) {
      paginationEl.addEventListener('click', (e) => {
        const link = e.target.closest('a[data-page]');
        if (!link) return;

        // Modified clicks open the real URL, e.g. in a new tab.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        e.preventDefault();
        this.load(el, parseInt(link.dataset.page, 10));
      });
    }
  },

  async load(el, page) {
    const sortEl       = el.querySelector('.posts-grid__sort');
    const filterEl     = el.querySelector('.posts-grid__filter');
    const cardsEl      = el.querySelector('.posts-grid__cards');
    const paginationEl = el.querySelector('.posts-grid__pagination');

    controllers.get(el)?.abort();
    const controller = new AbortController();
    controllers.set(el, controller);

    el.classList.add('posts-grid--loading');

    const body = new URLSearchParams({
      action:          postsGridAjax.action,
      post_type:       el.dataset.postType,
      per_page:        el.dataset.perPage,
      sort_by:         sortEl ? sortEl.value : 'date-desc',
      filter_term:     filterEl ? filterEl.value : '',
      event_type:      el.dataset.eventTypeFilter || 'all',
      page_param:      el.dataset.pageParam || '',
      base_url:        el.dataset.baseUrl || '',
      page,
    });

    try {
      const response = await fetch(postsGridAjax.ajax_url, { method: 'POST', body, signal: controller.signal });
      const data     = await response.json();

      if (!data.result) return;

      cardsEl.innerHTML      = data.cards_html;
      paginationEl.innerHTML = data.pagination_html;
      paginationEl.hidden    = !data.pagination_html.trim();

      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      if (err.name !== 'AbortError') console.error('posts-grid AJAX failed:', err);
    } finally {
      el.classList.remove('posts-grid--loading');
    }
  },
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => postsGrid.init());
} else {
  postsGrid.init();
}
